<template>
	<v-navigation-drawer color="primary" permanent :rail="rail">
		<template #prepend>
			<div class="drawer-header d-flex align-center pa-2">
				<div class="text-h6 text-truncate">IST.Connect</div>
				<v-btn
					:block="rail"
					class="ml-auto"
					density="comfortable"
					:icon="rail ? 'mdi-menu' : 'mdi-menu-open'"
					:ripple="false"
					rounded="0"
					variant="text"
					@click="toggleRail()"
				></v-btn>
			</div>
		</template>

		<v-list v-if="displayItems" nav>
			<template v-for="item in items" :key="item.title">
				<v-divider v-if="item.title === '-'" />
				<template v-else>
					<!-- Menu Item -->
					<menu-item v-if="!item.items" :item="item"></menu-item>
					<v-list-group v-else-if="item.items" v-model="item.active">
						{{ item.title }}
						<!-- Sub menu item -->
						<template v-for="subItem in item.items" :key="subItem.title">
							<v-divider v-if="subItem.title === '-'" />
							<v-list-item
								v-else
								:disabled="!subItem.to"
								link
								:prepend-icon="subItem.icon"
								:title="subItem.title"
								:to="subItem.to"
							/>
						</template>
					</v-list-group>
				</template>
			</template>
		</v-list>

		<template #append>
			<div class="pa-2">
				<v-list>
					<v-list-item
						class="pl-2 pr-2"
						color="success"
						:disabled="
							options?.managerUrl == '' || options?.managerUrl == undefined
						"
						:href="options?.managerUrl"
						link
						prepend-icon="mdi-office-building-cog-outline"
						:rounded="true"
						target="_blank"
						:title="$t('navigation.orgamanagement')"
					/>
				</v-list>
			</div>

			<div class="drawer-footer d-flex flex-column justify-center align-center pa-2"
			>
				<v-btn :block="rail" variant="text" @click="next()">
					<span class="fi" :class="flagClass"></span>
				</v-btn>
				<img class="ist-logo pl-1 pr-1" height="56" src="../assets/logo2.svg" />
				<version-number />
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script setup lang="ts">
	import { VersionNumber } from "@de/ist.style_components_v3";
	import { useCycleList, useToggle, whenever } from "@vueuse/core";
	import { storeToRefs } from "pinia";
	import { computed, ref } from "vue";
	import { useI18n } from "vue-i18n";

	import type DrawerMenuItem from "@/interfaces/DrawerMenuItemInterface";

	import { useUiStore } from "@/store/UiStore";

	import MenuItem from "./MenuItem.vue";

	defineProps<{
		displayItems: boolean;
	}>();
	const uiStore = useUiStore();
	const { options } = storeToRefs(uiStore);

	const { locale } = useI18n({ useScope: "global" });

	const items = ref<DrawerMenuItem[]>([
		{
			icon: "mdi-home",
			title: "navigation.dashboard",
			to: { name: "DashBoard" },
		},
		{
			icon: "mdi-table",
			title: "navigation.joboverview",
			to: { name: "JobOverview" },
		},
		{
			icon: "mdi-cog",
			title: "navigation.jobconfigs",
			to: { name: "JobConfig" },
		},
		{
			icon: "mdi-folder",
			title: "navigation.pluginsoverview",
			to: { name: "Plugins" },
		},
	]);

	const changeLanguage = (language: string) => {
		locale.value = language;
		localStorage.setItem("lang", language);
	};

	const [rail, toggleRail] = useToggle(false);
	const { next, state } = useCycleList(["de", "en"], {
		initialValue: locale.value as string,
	});
	whenever(state, changeLanguage);
	const flagClass = computed(() => {
		if (state.value === "en") {
			return "fi-us";
		}
		return `fi-${state.value}`;
	});

</script>

<style scoped lang="less">
	.drawer-header {
		height: 62px;
	}

	.drawer-footer {
		gap: 8px;
	}
</style>
